import I18n from 'I18n';
// @ts-expect-error untyped module
import * as SimpleDate from 'UIComponents/core/SimpleDate';
export function isScheduledForPastDate(schedule) {
  const date = schedule.getSimpleDate();
  if (!date) {
    return false;
  }
  const scheduledMoment = SimpleDate.toMomentPortalTz(date).set({
    hour: schedule.hour.values[0],
    minute: schedule.minute.values[0]
  });
  const currentMoment = I18n.moment.portalTz().set({
    second: 0,
    millisecond: 0
  });
  return scheduledMoment <= currentMoment;
}